export class CategoryModel {
    id: number | undefined;
    name: string | undefined;
    description: string | undefined;
    image: string | undefined;
    createdAt: number | undefined;
    updatedAt: number | undefined;
    storeId: number | undefined;
    store: any | undefined;
}